import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Theme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { InboxFilter, InboxFilterDirection } from '../../../sic-lib/types/InboxTypes';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setFilters } from '../../../store/inbox';

export default function NewRecentDirectionButtons({ compState, setCompState }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const filterState = useAppSelector(state => state.inbox.filters.filter);

    const handleSelect = (
        event: React.MouseEvent<HTMLElement>,
        direction: InboxFilterDirection,
    ) => {
        const nextDirection =
            filterState.direction !== direction
                ? filterState.direction !== InboxFilterDirection.none
                    ? InboxFilterDirection.none
                    : direction === InboxFilterDirection.incoming
                    ? InboxFilterDirection.incoming
                    : InboxFilterDirection.outgoing
                : InboxFilterDirection.none;

        if (setCompState && compState) {
            setCompState({
                filter: { ...filterState, direction: nextDirection },
            });
        } else {
            dispatch(
                setFilters({
                    filter: {
                        filter: {
                            ...filterState,
                            direction: nextDirection,
                        },
                    },
                }),
            );
        }
    };

    return (
        <ToggleButtonGroup
            exclusive
            onChange={handleSelect}
            aria-label="Show messages"
            size="small"
            className={classes.root}
        >
            <Tooltip title="Show incoming">
                <ToggleButton
                    value={InboxFilterDirection.incoming}
                    selected={
                        filterState.direction === InboxFilterDirection.none ||
                        filterState.direction === InboxFilterDirection.incoming
                    }
                    aria-label="Show incoming"
                    className={classes.income}
                >
                    <ArrowDownwardIcon />
                </ToggleButton>
            </Tooltip>
            <Tooltip title="Show outgoing">
                <ToggleButton
                    value={InboxFilterDirection.outgoing}
                    selected={
                        filterState.direction === InboxFilterDirection.none ||
                        filterState.direction === InboxFilterDirection.outgoing
                    }
                    aria-label="Show outgoing"
                    className={classes.outgoing}
                >
                    <ArrowUpwardIcon />
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        '& .MuiToggleButtonGroup-groupedHorizontal': {
            /* width, height to match icon buttons with size "small" */
            width: '30px',
            height: '30px',
            // border: 'none',
            //borderRadius: '50%',
        },
        '&.css-1gjgmky-MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped:not(:first-of-type)':
            {
                marginLeft: 0,
            },
    },
    income: {
        color: theme.palette.conversationTimelinePaper.main,
        '&.Mui-selected': {
            backgroundColor: theme.palette.conversationTimelinePaper.main,
            color: theme.palette.secondary.contrastText,
        },
        '&.Mui-selected:hover': {
            backgroundColor: theme.palette.pageNavigationBar.light,
        },
    },
    outgoing: {
        color: theme.palette.conversationTimelinePaper.light,
        '&.Mui-selected': {
            backgroundColor: theme.palette.conversationTimelinePaper.light,
            color: theme.palette.secondary.contrastText,
        },
        '&.Mui-selected:hover': {
            backgroundColor: theme.palette.pageNavigationBar.contrastText,
        },
    },
}));
interface Props {
    compState?: InboxFilter;
    setCompState?: React.Dispatch<Partial<InboxFilter>>;
}
